/* Copyright (c) The New York Times Company */ import { createContext } from "react";
/**
 * Provides the EditorView, as well as the current
 * EditorState. Should not be consumed directly; instead
 * see `useEditorState`, `useEditorViewEvent`, and
 * `useEditorViewLayoutEffect`.
 */ export const EditorContext = createContext(null);
